var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"folder-node-checkbox__root"},[_c('i',_vm._g({class:_vm.iconClass},_vm.$listeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }